import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Paths from './Paths';
import {BrowserRouter} from 'react-router-dom';
// import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <Paths />
    </BrowserRouter>
  </React.StrictMode>
);
